<template>
  <HeroBlog />
  <!-------------------------------TEST----------------------->
  <ArticleSelect :posts="Posts" />
  <!-------------------------------TEST----------------------->
</template>

<script>
import { useMeta } from "vue-meta";
import ArticleSelect from "@/components/blog/ArticleSelect.vue";
import HeroBlog from "@/components/blog/HeroBlog.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "BlogView",
  components: { ArticleSelect, HeroBlog },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  setup() {
    useMeta({
      title: "Livratos – Actualités et conseils autour de la livraison BTP",
      description: [
        {
          content:
            "Découvrez les articles du blog Livratos : actualités du secteur BTP, conseils pour artisans et fournisseurs, innovations logistiques et bonnes pratiques de livraison.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/blog",
        },
      ],
    });
  },

  created() {
    // Appel initial à GetPosts() pour récupérer tous les articles du blog
    this.$store.dispatch("GetPostsPublished");
  },

  computed: {
    ...mapGetters({
      Posts: "StatePosts",
      User: "StateUser",
      Post: "StatePost",
    }),
  },
  methods: {
    ...mapActions(["GetPostsPublished", "GetPost"]),
    async showPost(id) {
      try {
        await this.GetPost(id);
        this.$router.push({
          name: "article",
          params: { slug: this.Post.slug },
        });
        this.showError = false;
      } catch (error) {
        this.showError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
